import React, { useState } from 'react';
import styles from './ProfileImages.module.css';
import { Image } from 'react-bootstrap';
import Lightbox from 'react-image-lightbox';
import playIcon from './../../assets/images/play.png'

const classNames = require('classnames');

export default function ProfileImages({ profile, parentProfile }) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const featuredImage = profile.basic_info.featured_upload || (parentProfile ? parentProfile.basic_info.featured_upload : null)
  const virtualTourImage = profile.basic_info.virtual_tour_link || (parentProfile ? parentProfile.basic_info.virtual_tour_link : null)
  const images = [
    ...(featuredImage ? [featuredImage] : []),
    ...(virtualTourImage ? [`${virtualTourImage}${virtualTourImage.indexOf('play=1') < 0 ? '?play=1' : ''}`] : [])
  ]
  if (profile.photos && profile.photos.length) profile.photos.forEach(_ => images.push(_));

  const toggleModal = (index) => {
    setImageIndex(index);
    setModalIsOpen(!modalIsOpen);
  }

  const PlayIcon = () => {
    return (
      <Image src={playIcon} className={classNames(styles.playIcon, imageIndex === 1 ? 'd-none' : '')} onClick={() => setImageIndex(1)} />
    )
  }

  return (
    <>
      {images.length ?
        <>
          {imageIndex === 0 ?
            <div className={styles.heroImage}>
              <PlayIcon />
              <Image className='w-100 h-100' src={images[imageIndex]} fluid />
            </div>
            :
            <div className={classNames(styles.iframeContainer)}>
              {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
              <iframe src={images[imageIndex]} className={classNames('h-100 w-100 border-0', styles.iframe)}></iframe>
            </div>
          }
        </>
        : null}
      <div className={styles.heroImage} onClick={() => toggleModal(0)}>
        <Image className='w-100 h-100' src={images[0]} fluid />
      </div>
      <div className={classNames(styles.thumbImg, 'd-flex flex-nowrap overflow-auto flex-md-wrap align-items-start')}>
        {images.slice(1).map((photo, i) =>
          <Image key={`photo${i}`} className='w-50' src={photo} fluid onClick={() => toggleModal(i + 1)} />
        )}
      </div>
      {modalIsOpen && (
        <Lightbox
          mainSrc={images[imageIndex]}
          nextSrc={images[(imageIndex + 1) % images.length]}
          prevSrc={images[(imageIndex + images.length - 1) % images.length]}
          onCloseRequest={() => toggleModal(imageIndex)}
          onMovePrevRequest={() =>
            setImageIndex((imageIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() =>
            setImageIndex((imageIndex + 1) % images.length)
          }
        />
      )}
    </>
  )
}
